module.exports = __webpack_public_path__ + "img/button_service_off.d067d425.png";